export default __webpack_public_path__ + "static/media/ni.9b7c3993.svg";